/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Search',
  search_no_results_1: 'Oh no!',
  search_no_results_2: 'That emoji couldn’t be found',
  pick: 'Pick an emoji…',
  add_custom: 'Add custom emoji',
  categories_activity: 'Activity',
  categories_custom: 'Custom',
  categories_flags: 'Flags',
  categories_foods: 'Food & Drink',
  categories_frequent: 'Frequently used',
  categories_nature: 'Animals & Nature',
  categories_objects: 'Objects',
  categories_people: 'Smileys & People',
  categories_places: 'Travel & Places',
  categories_search: 'Search Results',
  categories_symbols: 'Symbols',
  skins_choose: 'Choose default skin tone',
  skins_1: 'Default',
  skins_2: 'Light',
  skins_3: 'Medium-Light',
  skins_4: 'Medium',
  skins_5: 'Medium-Dark',
  skins_6: 'Dark',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
